import {Injectable} from '@angular/core';
import {Paginator} from '../../models/paginator';
import {ApiService} from './api.service';
import {Builder} from '../../models/builder';
import {Model} from '../../models/model';

@Injectable()
export abstract class ApiImplementation {

  constructor(
    protected api: ApiService,
  ) {
  }

  protected abstract primaryKey: string;
  protected abstract base: string;

  abstract model(data?): Model;

  abstract paginator(data): Paginator<Model>;

  public get(id: number) {
    return this.api.get(this.base + '/' + id).then(data => {
      return this.transform(data['data']);
    });
  }

  public all(limit: number = 100, page: number = 1, options ?: Object): Promise<Paginator<Model>> {
    // Add options
    if (options == null) {
      options = {};
    }

    options['page']  = page;
    options['limit'] = limit;


    return this.api.get(this.base + this.optionsToQueryString(options)).then(data => {
      data['data']  = this.transform(data['data']);
      let paginator = this.paginator((data));

      return paginator;
    });
  }

  public save(model: Model): Promise<Model> {

    if (model[this.primaryKey] != null && model[this.primaryKey] > 0) {
      return this.update(model);
    } else {
      return this.store(model);
    }
  }

  private store(model: Model): Promise<Model> {
    return new Promise<Model>((resolve, reject) => {
      this.api.post(this.base + "/", model.serialize()).then(res => {
        return resolve(this.transform(res['data']));
      }, error => {
        reject(error);
      })
    })
  }

  private update(model: Model): Promise<Model> {
    return new Promise<Model>((resolve, reject) => {
      this.api.patch(this.base + "/" + model[this.primaryKey] + "/", model.serialize()).then(res => {
        return resolve(this.transform(res['data']));
      }, error => {
        reject(error);
      })
    })
  }

  public delete(model: Model): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.api.delete(this.base + "/" + model[this.primaryKey] + "/").then(res => {
        return resolve(res['success']);
      }, error => {
        return reject(error);
      })
    })
  }

  public transform(data) {
    let rc;
    if (data instanceof Array) {
      rc = [];
      data.forEach(elem => {
        rc.push(this.generate(elem));
      })
    } else {
      rc = this.generate(data);
    }
    return rc;
  }

  protected generate(data): Model {
    let model = this.model();

    model.fill(data);

    return model;
  }


  public optionsToQueryString(options?) {
    if (options == null) {
      options = {};
    }
    let opts = [];


    for (var key in options) {
      opts.push(key + "=" + options[key]);
    }

    let queryString = "";

    if (opts.length > 0) {
      queryString = "?" + opts.join("&");
    }

    return queryString;
  }

  public everything(builder = new Builder()) {
    return this.api.all(this.base, 1, [], '&' + builder.buildUrl());
  }

  /**
   * From Query Builder
   * @param builder
   */
  public fromBuilder(builder: Builder) {
    return this.api.get(this.base + '?' + builder.buildUrl());
  }

  public fromBuilderObserver(builder: Builder) {
    return this.api.observable.get(this.base + '?' + builder.buildUrl());
  }

}
